import { Link } from "react-router-dom";
import { brand } from "@mbb/config";
import Scallop from "../../components/Scallop";

const steps = [
  {
    n: "1",
    title: "Apply",
    body: "A short form. Tell us what you're reading and why this sounds like your kind of room.",
  },
  {
    n: "2",
    title: "Get approved",
    body: "We review every application personally. You'll hear back by email with a private invite link.",
  },
  {
    n: "3",
    title: "Set up your membership",
    body: "Pick a password. Pop in your card. Five dollars renews on the same day each month.",
  },
  {
    n: "4",
    title: "You're in",
    body: "The portal opens. The current read is waiting. Say hi in the discussion feed.",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="join"
      className="section section--blush"
      style={{ position: "relative" }}
    >
      <Scallop
        color="var(--c-sand)"
        height={32}
        flip
        style={{ position: "absolute", top: 0, left: 0, right: 0 }}
      />
      <div className="container" style={{ paddingTop: "2rem" }}>
        <div
          className="split split--5-7"
          style={{ marginBottom: "3rem" }}
        >
          <div>
            <div className="eyebrow" style={{ color: "var(--c-palm)" }}>
              How it works
            </div>
            <h2
              className="display display--lg"
              style={{ marginTop: "1rem", marginBottom: 0 }}
            >
              {brand.membershipPriceLabel}.
              <br />
              <em style={{ color: "var(--c-coral)" }}>that's it.</em>
            </h2>
          </div>
          <div className="stack">
            <p style={{ fontSize: "var(--t-body-lg)", lineHeight: 1.6 }}>
              Membership covers the books we send around, the snacks at meetups,
              and the time it takes to run a club this carefully. No long
              commitment — cancel any time from the portal.
            </p>
            <p style={{ lineHeight: 1.65 }}>
              Joining on the 20th means renewing on the 20th, every month. Same
              card, same day. We won't surprise you.
            </p>
          </div>
        </div>

        <ol
          style={{
            listStyle: "none",
            padding: 0,
            margin: 0,
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
            gap: "1.25rem",
          }}
        >
          {steps.map((s) => (
            <li
              key={s.n}
              style={{
                background: "var(--c-sand)",
                borderRadius: "var(--r-md)",
                padding: "1.75rem",
                borderTop: "4px solid var(--c-coral)",
              }}
            >
              <div
                style={{
                  fontFamily: "var(--f-display)",
                  fontSize: "2.5rem",
                  lineHeight: 1,
                  color: "var(--c-coral)",
                  fontStyle: "italic",
                }}
              >
                {s.n}
              </div>
              <h3
                style={{
                  marginTop: "0.5rem",
                  marginBottom: "0.5rem",
                  fontFamily: "var(--f-label)",
                  textTransform: "uppercase",
                  letterSpacing: "0.16em",
                  fontSize: "0.85rem",
                  color: "var(--c-palm)",
                }}
              >
                {s.title}
              </h3>
              <p style={{ margin: 0, lineHeight: 1.55 }}>{s.body}</p>
            </li>
          ))}
        </ol>

        <div style={{ marginTop: "3rem", textAlign: "center" }}>
          <Link to="/apply" className="btn btn--primary">
            Apply now
          </Link>
        </div>
      </div>
    </section>
  );
}
